// extracted by mini-css-extract-plugin
export default {"container":"subscriptionsByUser_container__M6fEN","loader":"subscriptionsByUser_loader__zdUYW","error":"subscriptionsByUser_error__3VJlt"};